import {Component} from '@angular/core';

@Component({
  selector: 'c-popup',
  template: '<router-outlet></router-outlet>'
})
export class PopupComponent {
}
